import React from 'react'
import PropTypes from 'prop-types'
import { IconButton, makeStyles } from '@material-ui/core'
import { Controller, useFormContext } from 'react-hook-form'
import Select from '../../../../molecules/Select'
import Icon from '../../../../atoms/Icon'
import FeeScheduleTiers from './FeeScheduleTiers'

const useStyles = makeStyles((theme) => ({
  feeScheduleAssignment: {},
  body: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px'
  },
  name: {
    maxWidth: '440px',
    minWidth: '440px',
    border: `2px solid ${theme.palette.gray.dark}`,
    height: '40px',
    display: 'flex',
    padding: '0 0 0 10px',
    alignItems: 'center',
    fontWeight: theme.typography.weights.light,
    '& .MuiIconButton-root': {
      color: theme.palette.danger.main,
      fill: theme.palette.danger.main
    }
  }
}))

function FeeScheduleAssignment ({
  name,
  editing,
  feeSchedules,
  feeScheduleOptions
}) {
  const classes = useStyles()
  const { setValue } = useFormContext()

  return (
    <div className={classes.feeScheduleAssignment}>
      <h2>Fee Schedule</h2>
      <div className={classes.body}>
        <div className={classes.name}>
          <Controller
            name={name}
            render={({ field, fieldState }) => (
              <Select
                placeholder='No Fee Schedule'
                readOnly={!editing}
                onChange={field.onChange}
                value={field.value}
                options={feeScheduleOptions}
                error={(fieldState.isTouched || fieldState.isDirty) && fieldState.error}
              />
            )}
          />
          {editing ? (
            <IconButton onClick={() => setValue(name, '', { shouldDirty: true, shouldTouch: true })}>
              <Icon name='removeCircle' />
            </IconButton>
          ) : null}
        </div>
        <Controller
          name={name}
          render={({ field }) => (
            <FeeScheduleTiers feeSchedule={feeSchedules.find(x => x.feeScheduleId === field.value)} />
          )}
        />
      </div>
    </div>
  )
}

FeeScheduleAssignment.propTypes = {
  name: PropTypes.string,
  editing: PropTypes.bool,
  feeSchedules: PropTypes.array,
  feeScheduleOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number
  }))
}

FeeScheduleAssignment.defaultProps = {
  name: 'feeScheduleId',
  editing: false
}

export default FeeScheduleAssignment
